document.addEventListener('DOMContentLoaded', () => {

const storageKey = 'lookWishlistItems'
let cache = new Set(JSON.parse(localStorage.getItem(storageKey) || '[]'))

/* ============================= */
/* ERROR MESSAGE + SHAKE        */
/* ============================= */

function showError(wrapper, message){

let error = wrapper.querySelector('.look-error-message')

if(!error){

error = document.createElement('div')
error.className = 'look-error-message'

const actions = wrapper.querySelector('.look-enterprise__actions')
actions?.parentNode.insertBefore(error, actions)

}

error.textContent = message
shakeVariants(wrapper)

}

function clearError(wrapper){

const error = wrapper.querySelector('.look-error-message')
if(error) error.remove()

}

function shakeVariants(wrapper){

const variants = wrapper.closest('.look-enterprise__item')
?.querySelectorAll('.look-enterprise__variant')

if(!variants) return

variants.forEach(el => {

el.classList.remove('look-variant-shake')
void el.offsetWidth
el.classList.add('look-variant-shake')

setTimeout(()=> el.classList.remove('look-variant-shake'),450)

})

}

/* ============================= */
/* SYNC COM SWYM                */
/* ============================= */

function syncWithSwym() {

if (!window._swat) return

window._swat.fetch(function(wishlist) {

cache.clear()

if (wishlist && wishlist.length) {

wishlist.forEach(item => {

const productId = item.empi || item.product_id
const variantId = item.epi || item.variant_id

if (productId && variantId) {
cache.add(`${productId}-${variantId}`)
}

})

}

localStorage.setItem(storageKey, JSON.stringify([...cache]))
updateAllHearts()

})

}

function updateAllHearts() {

document.querySelectorAll('[data-look-wishlist]').forEach(btn => {

const productId = btn.dataset.productId
const wrapper = btn.closest('[data-look-form]')
const hiddenInput = wrapper?.querySelector('[data-look-variant-id]')
const svgPath = btn.querySelector('path')

if (!hiddenInput || !svgPath) return

const variantId = hiddenInput.value

svgPath.setAttribute(
'fill',
cache.has(`${productId}-${variantId}`) ? 'currentColor' : 'none'
)

})

}

if (window._swat) {
syncWithSwym()
} else {
document.addEventListener('swym:ready', syncWithSwym, { once: true })
}

window.addEventListener('pageshow', syncWithSwym)

/* ============================= */
/* INIT LOOK FORMS              */
/* ============================= */

function initLookForms(){

document.querySelectorAll('[data-look-form]').forEach(wrapper => {

if(wrapper.dataset.lookInit === "true") return
wrapper.dataset.lookInit = "true"

const form = wrapper.querySelector('form')
const hiddenInput = wrapper.querySelector('[data-look-variant-id]')
const button = wrapper.querySelector('.add-to-cart-button')
const item = wrapper.closest('.look-enterprise__item')
const radios = item?.querySelectorAll('[data-look-variant]')
const wishlistBtn = wrapper.querySelector('[data-look-wishlist]')
const lookPrincipal = wrapper.dataset.lookPrincipal
const produtoLook = wrapper.dataset.lookProduto

if (!form || !hiddenInput || !button || !item) return

resetButton()

/* VARIANTS */

radios?.forEach(radio => {

radio.addEventListener('change', () => {

const label = radio.closest('.look-enterprise__variant')
const available = label?.dataset.available === 'true'

hiddenInput.value = radio.value

available ? setButtonAvailable() : setButtonSoldOut()

clearError(wrapper)

updateAllHearts()

})

})

/* FAVORITOS */

if (wishlistBtn) {

const svgPath = wishlistBtn.querySelector('path')
const productId = wishlistBtn.dataset.productId

wishlistBtn.addEventListener('click', () => {

const variantId = hiddenInput.value

if (!variantId){
showError(wrapper,'Selecione um tamanho')
return
}

if (!window._swat) return

window._swat.addToWishList({
epi: Number(variantId),
empi: Number(productId),
du: `${window.location.origin}${item.querySelector('a').getAttribute('href')}?variant=${variantId}`
}, () => {

cache.add(`${productId}-${variantId}`)
localStorage.setItem(storageKey, JSON.stringify([...cache]))

svgPath.setAttribute('fill','currentColor')

})

})

}

/* ADD TO CART */

form.addEventListener('submit', async e => {

e.preventDefault()

if(button.dataset.loading === "true") return
button.dataset.loading = "true"

if (!hiddenInput.value){
showError(wrapper,'Selecione um tamanho')
button.dataset.loading = "false"
return
}

/* grava atributo global do carrinho */
await fetch('/cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    attributes: {
      origem_compra: 'COMPLETE_O_LOOK',

      /* relatório */
      look_principal: lookPrincipal,

      /* versão do recurso */
      look_recurso: 'ENTERPRISE_V1'
    }
  })
})

/* adiciona o produto */
await fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    id: Number(hiddenInput.value),
    quantity: 1,

    properties: {
      '_Origem': 'LOOK_ENTERPRISE',
      '_Recurso': 'Complete o Look',
      '_Versao': 'Enterprise',

      '_LookPrincipal': lookPrincipal,
      '_ProdutoLook': produtoLook,
      '_VariantId': Number(hiddenInput.value)
    }
  })
})

await window.FabricBridge?.refreshCart()

pulseCartBubble()
window.FabricBridge?.openCartDrawer()

button.dataset.loading = "false"

})

/* BUTTON STATES */

function resetButton(){
hiddenInput.value = ''
button.disabled = true
setText('Adicionar ao carrinho')
}

function setButtonAvailable(){
button.disabled = false
setText('Adicionar ao carrinho')
}

function setButtonSoldOut(){
button.disabled = true
setText('Esgotado')
}

function setText(text){
const el = button.querySelector('.add-to-cart-text')
if(el) el.textContent = text
}

})

}

initLookForms()

/* ============================= */
/* CART BADGE ANIMATION         */
/* ============================= */

let cartBubble = document.querySelector(".cart-bubble")
let cartNumber = document.querySelector(".cart-bubble__text-count")

window.pulseCartBubble = function(){

cartBubble = document.querySelector(".cart-bubble")
cartNumber = document.querySelector(".cart-bubble__text-count")

if (!cartBubble || !cartNumber) return

cartBubble.classList.remove("cart-badge--pulse")
cartNumber.classList.remove("cart-number--animate")

void cartBubble.offsetWidth

cartBubble.classList.add("cart-badge--pulse")
cartNumber.classList.add("cart-number--animate")

}

/* ============================= */
/* LOOK TOP ACTIVE STATE        */
/* ============================= */

document.addEventListener('click', e => {

const btn = e.target.closest('[data-look-top]')
if(!btn) return

document.querySelectorAll('[data-look-top]')
.forEach(b => b.classList.remove('is-active'))

btn.classList.add('is-active')

})






/* ============================= */
/* LOOK ENTERPRISE SWITCH FINAL */
/* ============================= */

const cardCache = new Map()

document.addEventListener('click', async (e) => {

  const btn = e.target.closest('a')
  if (!btn) return

  const container = btn.closest('.look-enterprise__items')
  if (!container) return

  const isMain = container.dataset.mainProduct === "true"

  const comp1El = container.querySelector('#look-comp1')
  const comp2El = container.querySelector('#look-comp2')

  // =========================
  // 🔥 CASO 3 PRODUTOS
  // =========================
if (btn.hasAttribute('data-look-switch') && comp1El && comp2El && isMain) {

  e.preventDefault()

  const buttons = container.querySelectorAll('[data-look-switch]')
  buttons.forEach(b => b.classList.remove('is-active'))

  btn.classList.add('is-active')

  const isFirst = btn === buttons[0]

  const incoming = isFirst ? comp1El : comp2El
  const outgoing = isFirst ? comp2El : comp1El

  // 🔥 anima saída
  const oldCard = outgoing.querySelector('.look-enterprise__item')
  if (oldCard) {
    oldCard.classList.add('look-enterprise__item--animating')
  }

  setTimeout(() => {

    outgoing.classList.remove('active')
    incoming.classList.add('active')

const newCard = incoming.querySelector('.look-enterprise__item')

if (newCard) {

  // RESET
  newCard.classList.remove('look-enterprise__item--animating', 'look-enterprise__item--show')

  void newCard.offsetWidth

  // ANIMA ENTRADA
  newCard.classList.add('look-enterprise__item--animating')

  requestAnimationFrame(() => {
    newCard.classList.add('look-enterprise__item--show')
  })

  // 🔥 LIBERA CLIQUE DEPOIS DA ANIMAÇÃO
  setTimeout(() => {
    newCard.classList.remove('look-enterprise__item--animating')
  }, 400)

}

  }, 120)

  return
}

  // =========================
  // 🔥 CASO 4 PRODUTOS
  // =========================
  if (!btn.closest('.look-enterprise__model-selector--bottom')) return

  e.preventDefault()

  const url = btn.href

  const wrapper = btn.closest('.look-enterprise')

  wrapper.querySelectorAll('.look-enterprise__model-selector--bottom .look-enterprise__model-button')
    .forEach(b => b.classList.remove('is-active'))

  btn.classList.add('is-active')

  let newCard

  if (cardCache.has(url)) {

    newCard = cardCache.get(url).cloneNode(true)

  } else {

    const res = await fetch(url, { cache: "no-store" })
    const html = await res.text()

    const temp = document.createElement('div')
    temp.innerHTML = html

const fetchedTarget = temp.querySelector('#look-bottom-target')

if (fetchedTarget) {
  newCard = fetchedTarget.querySelector('.look-enterprise__item')
} else {
  // fallback seguro (evita sumir tudo)
  newCard = temp.querySelector('.look-enterprise__item:last-child')
}

    if (newCard) {
      cardCache.set(url, newCard.cloneNode(true))
    }
  }

  // 🔥 CORREÇÃO AQUI
  const target = wrapper.querySelector('#look-bottom-target')
const oldCard = target?.querySelector('.look-enterprise__item')

if (target && newCard) {

  const oldCard = target.querySelector('.look-enterprise__item')

  if (oldCard) {
    oldCard.classList.add('look-enterprise__item--animating')
  }

  setTimeout(() => {

    newCard.classList.add('look-enterprise__item--animating')

    target.innerHTML = ''
    target.appendChild(newCard)

    newCard.offsetHeight

    newCard.classList.add('look-enterprise__item--show')

    initLookForms()

  }, 150)
}

})
})